
export const theme_ns: ThemeNS = 'malloftripla2024';
